import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const incomeSpecialRoutes = {
    GET_MONTHLY_TYPES: "dashboard/income/special/list/type",
};
export default {
    listIncomeSpecialTypes() {
        let newInfo = {};
        return new Promise(resolve => {
            http
                .get(incomeSpecialRoutes.GET_MONTHLY_TYPES)
                .then(({data}) => {
                    const code = data.code;
                    if (code === 0) {
                        toast.info("No se encontraron tipos de mensualidad");
                        return;
                    }
                    if (code < 0) {
                        toast.error("Error al consultar tipos de mensualidad");
                        return;
                    }
                    newInfo = data;
                })
                .catch(ex => {
                    toast.error("Error al consultar tipos de mensualidad",ex);
                })
                .finally(() => resolve(newInfo));
        });
    },
}